// Typed wrappers for POST /v1/platform/buckzy-credentials.
//
// Admin-only, singleton-current: at most one active platform-Buckzy credential
// set globally. A second POST returns 409 platform_buckzy_credential_exists
// (the panel surface should disable the form once a current set exists).
//
// BFF rule (CLAUDE.md rule 1): goes through apiClient. Response carries NO
// credential field — pitfall-6-safe.
import { apiClient } from "./client";

export interface CreatePlatformBuckzyCredentialPayload {
  client_id: string;
  client_secret: string;
  api_key: string;
  username: string;
  password: string;
  api_url: string;
  auth_url: string;
  /**
   * Buckzy partyId for the PLATFORM. Used as debtor.reference on payouts.
   * REQUIRED — backend rejects with 400 invalid_request when omitted
   * (binding tag, see AUDIT-PASS-10 BE-H5). Pre-fix the TS type was
   * optional and the panel stripped blanks to `undefined`, which made
   * the half-formed save look like a generic 400 instead of a missing-field
   * error.
   */
  merchant_party_id: string;
  /** Buckzy account reference for the platform's settlement account. REQUIRED — see above. */
  settlement_account_id: string;
}

export interface PlatformBuckzyCredentialResult {
  platform_buckzy_credential_id: number;
  created_at: string;
}

export async function createPlatformBuckzyCredential(
  payload: CreatePlatformBuckzyCredentialPayload,
): Promise<PlatformBuckzyCredentialResult> {
  const resp = await apiClient.post<PlatformBuckzyCredentialResult>(
    `/v1/platform/buckzy-credentials`,
    payload,
  );
  return resp.data;
}
